export default __webpack_public_path__ + "static/media/netflixIcon.ceb60baf.svg";